<template>
  <div class="dictindex">
    <el-card class="box-card">
      <div class="container">
        <div class="about2">
          <div class="wrapper clearfix-time">
            <div class="tit">
              <h6 style="font-size: 16px">天宙检测科技有限公司</h6>
              <h5 class="f24">发展历程</h5>
            </div>
            <ul class="clearfix-time historyList">
              <li v-for="element in history" :key="element.title">
                <el-button
                  @click="handleEdit(element)"
                  type="primary"
                  class="toEdit"
                  size="mini"
                >
                  编辑
                </el-button>
                <el-button
                  @click="deleteFn(element)"
                  type="danger"
                  class="toEdit"
                  size="mini"
                >
                  删除
                </el-button>
                <h4 class="f30">{{ element.title }}年</h4>
                <p class="f14" v-html="formatContent(element.content)"></p>
              </li>
            </ul>
            <div class="future">...</div>
            <div class="future">
              <el-button
                @click="handleEdit(element)"
                type="warning"
                class="toEdit"
                size="mini"
              >
                添加
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    />
  </div>
</template>
<script>
import { pageList, updateList, addList, deleteList } from '@/api/timeAxis'
// import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    Edit
  },
  data() {
    return {
      editState: false,
      editUnit: {},
      history: []
    }
  },
  methods: {
    // 列表
    getDictList() {
      pageList().then((res) => {
        if (res.code == 200) {
          this.history = res.data
        }
      })
    },
    formatContent(content) {
      if (!content) return ''
      return content
        .split('&&')
        .map((item) => {
          return `<span class='dot'></span> ${item}`
        })
        .join('<br>') // 用 <br> 分隔每项
    },

    handleEdit(e) {
      if (e) {
        this.editUnit = JSON.parse(JSON.stringify(e))
      }
      // 显示弹框
      this.editState = true
    },
    // 编辑
    changeDict(infos) {
      // this.$loading({
      //   text: '信息更新中'
      // })
      let params = {
        type: 99,
        ...infos
      }
      if (params.id) {
        updateList(params).then((res) => {
          if (res.code == 200) {
            this.editState = false
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getDictList()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
      } else {
        addList(params).then((res) => {
          // console.log(res.data, '创建')
          if (res.code == 200) {
            this.editState = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.getDictList()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
      }
      // this.$loading().close()

      setTimeout(() => {
        this.$loading().close()
      }, 1000)
    },

    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteList(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getDictList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  },
  mounted() {
    this.getDictList()
  }
}
</script>

<style scoped>
.span {
  display: inline-block;
  color: #47bb8f;
  font-size: 18px;
}
.dot {
  display: inline-block;
  color: #47bb8f;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #47bb8f;
  font-size: 18px;
  margin-right: 5px;
}
.about2 {
  padding-bottom: 80px;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td,
img,
area,
param {
  margin: 0;
  padding: 0;
}
body {
  font-size: 12px;
}
/* .wrapper{box-sizing:border-box;width:90%;margin:auto;max-width:1200px;} */
html[xmlns] .clearfix-time {
  display: block;
}
body {
  font-size: 12px;
}
.about2 .tit {
  text-align: center;
}
.about2 ul {
  background: url(./../../assets/images/about/sy51.png) repeat-y center;
}
.clearfix-time {
  display: block;
  zoom: 1;
}
ol,
ul {
  padding-left: 0;
  list-style: none;
}
.about2 .tit h6 {
  color: #666;
}
.f12 {
  font-size: 12px;
}
th {
  font-style: normal;
  font-weight: normal;
}
/* h1,
h2,
h3,
h4,
h5,
h6 {
  /* font-size: 100%; 
  font-weight: normal;
} */
.about2 .tit h5 {
  color: #333;
  margin: 15px 0 45px;
}
.f24 {
  font-size: 24px;
}
.about2 li:before {
  background: url(./../../assets/images/about/sy50.png) no-repeat center center;
  left: -67px;
  top: 12px;
  content: '';
  display: block;
  position: absolute;
  width: 17px;
  height: 17px;
}
.about2 li h4:hover {
  color: #f8f8f8;
  transition: all 1s;
  transform: translateY(-15px);
}

.about2 li h4 {
  position: relative;
  display: block;
  text-decoration: none;
  font-family: 'Lato';
  color: #ecf0f1;
  text-transform: uppercase;
  padding: 4px 0;
  transition: 0.5s;
}
.about2 li h4::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 1px;
  top: 100%;
  left: 0;
  background: #47bb8f;
  transition: transform 0.5s;
  transform: scaleX(0);
  transform-origin: right;
}
.about2 li h4:hover {
  color: #95a5a6;
}
.about2 li h4:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.f30 {
  font-size: 30px;
}
.f14 {
  font-size: 14px;
}
.about2 li:nth-child(2n):before {
  background: url(./../../assets/images/about/sy50.png) no-repeat center center;
  right: -67px;
  top: 12px;
  left: auto;
  content: '';
  display: block;
  position: absolute;
  width: 17px;
  height: 17px;
}
.about2 li h4 {
  color: #333;
  transition: all 1s;
}
.about2 li p {
  color: #666;
  margin-top: 10px;
  /* height: 60px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.future {
  text-align: center;
  color: #999;
  font-size: 16px;
  margin-top: 17px;
}
.clearfix-time:after {
  content: '\20';
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}
.about2 li:nth-child(1) {
  margin-top: 0;
}
/* 表示1-3之间的间距 */
.about2 li {
  float: right;
  width: 45%;
  text-align: left;
  position: relative;
  margin-top: 15vh;
}
.about2 li:nth-child(2n) {
  float: left;
  text-align: right;
  margin-top: 15vh;
}
</style>
